import { isNull } from 'lodash/fp';

import { ApplicationState } from '../../../../store/types';
import { Notification, SystemNotification, ActiveMLDocument, TestMLDocument, ActiveMLOpinion, ActiveFewShotDocument } from './types';
import { getNotificationsRoot } from '../../store/selectors';

export const getNotifications = (state: ApplicationState): Notification[] => getNotificationsRoot(state).notifications;

export const getNotificationsModalOpen = (state: ApplicationState): boolean => getNotificationsRoot(state).modalOpen;

export const getSystemNotification = (state: ApplicationState): SystemNotification | null => getNotificationsRoot(state).systemNotification;

export const getSystemNotificationModalOpen = (state: ApplicationState): boolean => !isNull(getSystemNotification(state));

export const getMLProgressModalOpen = (state: ApplicationState): boolean => getNotificationsRoot(state).mlProgressModalOpen;

export const getActiveMLDocuments = (state: ApplicationState): ActiveMLDocument[] => getNotificationsRoot(state).activeMLDocuments;

export const getActiveMLOpinions = (state: ApplicationState): ActiveMLOpinion[] => getNotificationsRoot(state).activeMLOpinions;

export const getActiveFewShotDocuments = (state: ApplicationState): ActiveFewShotDocument[] => getNotificationsRoot(state).activeFewShotDocuments;

export const getShowMLInProgressIndicator = (state: ApplicationState): boolean => getActiveMLDocuments(state).length > 0 || getTestMLDocuments(state).length > 0 || getActiveMLOpinions(state).length > 0 || getActiveFewShotDocuments(state).length > 0;

export const getShowMLHourglassIndicator = (state: ApplicationState): boolean => [...getActiveMLDocuments(state), ...getTestMLDocuments(state), ...getActiveMLOpinions(state), ...getActiveFewShotDocuments(state)].filter(({ progress }) => ![0, 100].includes(progress)).length > 0;

export const getShowPortfolioStatistics = (state: ApplicationState): boolean => getNotificationsRoot(state).showPortfolioStatistics;

export const getPortfolioStatistics = (state: ApplicationState): string[] => getNotificationsRoot(state).portfolioStatistics;

export const getShowPortfolioStatisticsBanner = (state: ApplicationState): boolean => getShowPortfolioStatistics(state) && getPortfolioStatistics(state).length > 0;

export const getTestMLDocuments = (state: ApplicationState): TestMLDocument[] => getNotificationsRoot(state).testMLDocuments;
